import { render } from "./fsrPage404.vue?vue&type=template&id=238b3d36"
const script = {}

import "./fsrPage404.vue?vue&type=style&index=0&id=238b3d36&lang=css"

import exportComponent from "/datamining/www/front-vue.m-direct.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__